<template>
  <div class="eu-flex eu-column eu-row_sm">
    <div class="eu-flex-item" v-if="!isCreditCard">
      <a :href="`https://wa.me/?text=Link para pagamento: ${createdOrderResponse.payment_url}`" class="emd-link" target="_blank" data-action="share/whatsapp/share" v-if="!isPix">
        <i class="uil uil-whatsapp"></i>
        {{ $t('share.whatsapp') }}
      </a>
      <pix-clipboard-copy v-if="isPix" />
    </div>
    <div class="eu-flex-item" v-if="showEmailSend">
      <a href="javascript:void(0);" class="emd-link" @click="createEmailNotification">
        <i v-if="loadingEmail" class="emd-text _color_subtle uil uil-spinner-alt"></i>
        <i v-if="emailSent && !loadingEmail" class="uil uil-check-circle"></i>
        <i v-if="!emailSent && !loadingEmail" class="uil uil-envelope"></i>
        {{ $t('share.email') }}
      </a>
    </div>
  </div>
</template>

<script>
import PixClipboardCopy from '@/components/project/OrderCreated/PixClipboardCopy'
export default {
  name: 'OrderCreatedShare',
  components: {
    PixClipboardCopy
  },
  computed: {
    showEmailSend () {
      return !this.isPaymentTypeTypedSale && (this.permissionIsEnabled('shop.checkout.notification:create') || this.permissionIsEnabled('shop.recurrence.notifications:create'))
    },
    createdOrderResponse () {
      if (this.selectedPaymentTypeItemsOrTypedSale) return this.$store.getters.createdOrderResponse.payments[0]
      else return this.$store.getters.createdOrderResponse
    },
    selectedPaymentTypeItemsOrTypedSale () {
      return ['items', 'typed-sale'].includes(this.selectedPaymentType)
    },
    isPaymentTypeTypedSale () {
      return this.selectedPaymentType === 'typed-sale'
    },
    orderId () {
      return this.$store.getters.createdOrderResponse.id
    },
    accountId () {
      return this.$store.getters.accountData.id
    },
    merchantId () {
      return this.$store.getters.merchantData.id
    },
    isCreditCard () {
      return this.createdOrderResponse.payment_method === 'credit_card' || this.selectedPaymentType === 'subscription'
    },
    selectedPaymentType () {
      return this.$store.getters.selectedPaymentType
    },
    isPix () {
      return this.createdOrderResponse.payment_method === 'pix'
    }
  },
  data () {
    return {
      emailSent: false,
      loadingEmail: false,
      error: {
        status: false,
        title: 'error.email.title'
      }
    }
  },
  methods: {
    createEmailNotification () {
      this.loadingEmail = true
      const params = {
        merchantId: this.merchantId,
        accountId: this.accountId,
        orderId: this.orderId
      }
      const action = this.selectedPaymentType === 'items' ? 'CREATE_ORDER_EMAIL_NOTIFICATION' : 'CREATE_SUBSCRIPTION_EMAIL_NOTIFICATION'
      this.$store.dispatch(action, params)
        .then(res => {
          this.loadingEmail = false
          this.emailSent = true
          setTimeout(() => {
            this.emailSent = false
          }, 3000)
        })
        .catch(() => {
          this.loadingEmail = false
          this.error.status = true
          this.error.title = this.$t('error.email.title')
          this.$emit('emailError', this.error)
        })
    },
    permissionIsEnabled (action) {
      return this.$store.getters.permissionIsEnabled(action)
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "status": {
        "approved": "Seu pedido foi realizado e o pagamento já foi aprovado, compartilhe o comprovante com o seu cliente.",
        "pending": "O pagamento no cartão de final {creditCard} está sendo processado, o status do pedido pode ser acompanhado no dash da conta.",
        "paid": {
          "checkout": "Seu pedido {orderId} no valor de {totalAmount} pode ser pago neste link",
          "boleto": "O boleto no valor de {totalAmount} foi gerado e pode ser pago até o dia {due_at}"
        }
      },
      "share": {
        "whatsapp": "Compartilhar por whatsapp",
        "email": "Enviar por e-mail"
      },
      "error": {
        "email": {
          "title": "Erro ao enviar email."
        }
      }
    },
    "en-US": {
      "status": {
        "approved": "Your order was created and the payment has been approved, share the ticket with your custumer.",
        "pending": "The payment with the last card digits {creditCard} is being processed, you can follow the order status at the dash account.",
        "paid": {
          "checkout": "Your order {orderId} of {totalAmount} can be paid at this link",
          "boleto": "The boleto of {totalAmount} was generated and can be paid until {due_at}"
        }
      },
      "share": {
        "whatsapp": "Share at whatsapp",
        "email": "Send by e-mail"
      },
      "error": {
        "email": {
          "title": "Could not send email."
        }
      }
    }
  }
</i18n>
